import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import "./pacing-looker-dashboard.styles.scss";

const PacingLookerDashboard: React.FC = () => {
  return (
    <Box className="pacing-looker-dashboard">
      <Paper elevation={1} sx={{ height: "100vh", overflow: "hidden" }}>
        <iframe
          src="https://lookerstudio.google.com/embed/reporting/972a7ee2-3406-454e-a52f-e91ea5f08d50/page/4iedF"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
          title="Pacing Looker Studio Report"
          allowFullScreen
        />
      </Paper>
    </Box>
  );
};

export default PacingLookerDashboard;
